export const newPageNotificationModal = {
	title: "Tout au même endroit !",
	content:
		"Nous avons repensé cet écran pour que vous puissiez créer et gérer vos produits avec plus de praticité et d'organisation. Explorez le nouveau flux à votre rythme.",
	primaryActionLabel: "Voir les nouveautés",
};
